/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeboxing a standard half-hour meeting.`)
};

const es_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acotar el tiempo de una reunión estándar de media hora.`)
};

const de_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein übliches halbstündiges Meeting zeitlich begrenzen.`)
};

const nl_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een standaard vergadering van een half uur timeboxen.`)
};

const fr_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limiter dans le temps une réunion standard d’une demi-heure.`)
};

const it_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delimitare nel tempo una riunione standard di mezz'ora.`)
};

const pt_br2_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitar o tempo de uma reunião padrão de meia hora.`)
};

const pt_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delimitar no tempo uma reunião padrão de meia hora.`)
};

const ja_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準的な30分のミーティングを時間で区切る。`)
};

const zh_timer_u30m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为标准的半小时会议设定时间限制。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_use2", locale)
	if (locale === "en") return en_timer_u30m_use2(inputs)
	if (locale === "es") return es_timer_u30m_use2(inputs)
	if (locale === "de") return de_timer_u30m_use2(inputs)
	if (locale === "nl") return nl_timer_u30m_use2(inputs)
	if (locale === "fr") return fr_timer_u30m_use2(inputs)
	if (locale === "it") return it_timer_u30m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_use2(inputs)
	if (locale === "pt") return pt_timer_u30m_use2(inputs)
	if (locale === "ja") return ja_timer_u30m_use2(inputs)
	return zh_timer_u30m_use2(inputs)
};